export const capitalize = (s: string) =>
  `${s.slice(0, 1).toUpperCase()}${s.slice(1)}`;

export const formatWord = (word: string) =>
  word.split('_').map(capitalize).join(' ');
